import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import TextLabel from '../textLabel';

var CharLimit = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CharLimit, _React$PureComponent);

  var _super = _createSuper(CharLimit);

  function CharLimit() {
    _classCallCheck(this, CharLimit);

    return _super.apply(this, arguments);
  }

  _createClass(CharLimit, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          getClassName = _this$props.getClassName,
          dataHook = _this$props.dataHook;
      return /*#__PURE__*/React.createElement("span", {
        "data-hook": dataHook,
        className: getClassName('char-limit')
      }, /*#__PURE__*/React.createElement(TextLabel, {
        dataHook: "".concat(dataHook, "-label"),
        type: "T04",
        value: this._getDisplayValue(),
        shouldTranslate: false,
        className: getClassName("char-limit-label".concat(this._validate() ? '' : '-error'))
      }));
    }
  }, {
    key: "_validate",
    value: function _validate() {
      var _this$props2 = this.props,
          maxValue = _this$props2.maxValue,
          value = _this$props2.value,
          onValidation = _this$props2.onValidation;
      var isValid = maxValue ? value <= maxValue : true;

      if (onValidation) {
        onValidation(isValid);
      }

      return isValid;
    }
  }, {
    key: "_getDisplayValue",
    value: function _getDisplayValue() {
      var _this$props3 = this.props,
          value = _this$props3.value,
          maxValue = _this$props3.maxValue,
          minThreshold = _this$props3.minThreshold,
          maxThreshold = _this$props3.maxThreshold;

      if (maxValue && value > maxValue - maxThreshold) {
        return "".concat(value, "/").concat(maxValue);
      }

      return value >= minThreshold ? "".concat(value) : '';
    }
  }]);

  return CharLimit;
}(React.PureComponent);

CharLimit.displayName = 'CharLimit';
CharLimit.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /** Current input length */
  value: PropTypes.number,

  /** Max characters allowed in input */
  maxValue: PropTypes.number,

  /** Minimum number of characters needed to show counter */
  minThreshold: PropTypes.number,

  /** The required distance from maxLength for displaying the value limitation */
  maxThreshold: PropTypes.number,

  /** Validation callback, expects validation boolean result */
  onValidation: PropTypes.func
};
CharLimit.defaultProps = {
  minThreshold: 1,
  maxThreshold: 10,
  onValidation: function onValidation() {}
};
export default compose(CharLimit);